import RouteView from "../../navigation/RouteView";
import { processRoute } from "./navigation";
import ProcessPage from "./ProcessPage";

export default function ProcessNavigator() {
    return <RouteView route={processRoute} component={ProcessPage} />;
}
